import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { getSMPBackendAPIAdmin } from '@/proxy';
import { toResourceFilterOption } from '@/services';

function getResourceFilterOptions() {
  return getSMPBackendAPIAdmin().resourcesControllerGetFilterOptionsV1();
}

export function useResourceFilterOptions() {
  return useQuery({
    queryKey: queryKeys.resources.filterOptions(),
    queryFn: () => getResourceFilterOptions(),
    select: (data) => toResourceFilterOption(data),
  });
}
